import React from 'react';
import {ITask, ITaskList} from "../../ModelContracts";
import {Draggable, Droppable} from "react-beautiful-dnd";
import TaskCard from "../TaskCard/TaskCard";

import './TaskList.css';
import {Button} from "../ui";

interface IProps {
	taskList: ITaskList,
	emptyText?: string,
	onAdded?: Function | undefined,
	isAdmin: boolean
}

function TaskList({taskList, emptyText, onAdded, isAdmin}: IProps) {
	const handleAddClicked = () => {
		if (!onAdded) return;
		onAdded();
	}

	return (
		<div
			role="list"
			aria-label={taskList.name}
			className="task-list bg-base-300 p-4">
			<div className="flex flex-row items-center justify-between">
				<h4 className="h5">{taskList.name}</h4>
				{
					Boolean(onAdded) &&
					isAdmin &&
            <Button variant="link" title="Add Task" onClick={handleAddClicked} className="p-0">
                <span className="sr-only">Add Task</span>
                <i className="bi bi-plus-lg text-xl text-secondary"></i>
            </Button>
				}
			</div>
			<Droppable droppableId={taskList.id}>
				{
					(provided, snapshot) => (
						<div
							ref={provided.innerRef}
							className="items"
							{...provided.droppableProps}>
							{
								taskList.tasks.map((t: ITask, i: number) => (
									<Draggable key={t.id} draggableId={t.id} index={i}>
										{
											(providedDraggable, snapshotDraggable) => (
												<div
													ref={providedDraggable.innerRef}
													{...providedDraggable.draggableProps}
													{...providedDraggable.dragHandleProps}>
													<TaskCard key={t.id} task={t}/>
												</div>
											)
										}
									</Draggable>
								))
							}
							{
								taskList.tasks.length <= 0 && <p>{emptyText || "Nothing to show here."}</p>
							}
							{provided.placeholder}
						</div>
					)
				}
			</Droppable>
		</div>

	);
}

export default TaskList;
